import styled, { css } from '@xstyled/styled-components';
import LightBulbSvg from '~/assets/icons/light_bulb.svg';
import AudioSvg from '~/assets/icons/audio.svg';
import CardsSvg from '~/assets/icons/cards.svg';
import DocumentSvg from '~/assets/icons/document.svg';
import FlagSvg from '~/assets/icons/flag.svg';
import InterrogationSvg from '~/assets/icons/interrogation.svg';
import VideoSvg from '~/assets/icons/video.svg';
import AttentionSvg from '~/assets/icons/noun_attention.svg';
import HeartSvg from '~/assets/icons/noun_heart.svg';
import StarSvg from '~/assets/icons/noun_star.svg';
import ThumbUpSvg from '~/assets/icons/noun_thumb_up.svg';
import ThumbDownSvg from '~/assets/icons/noun_thumb_down.svg';
import LockSvg from '~/assets/icons/noun_lock.svg';
import PasswordSvg from '~/assets/icons/noun_password.svg';
import SlidersSvg from '~/assets/icons/noun_sliders.svg';

export type IconVariants =
  | 'light_bulb'
  | 'audio'
  | 'cards'
  | 'document'
  | 'flag'
  | 'interrogation'
  | 'video'
  | 'question'
  | 'attention'
  | 'heart'
  | 'star'
  | 'thumb_up'
  | 'thumb_down'
  | 'lock'
  | 'password'
  | 'sliders'
;

const baseStylesForIcon = css`
  float: left;
  max-width: 12px;
  max-height: 12px;
  margin-right: 8px;
  fill: accentDark;
`;

const LightBulbIcon = styled(LightBulbSvg)`
  ${baseStylesForIcon}
`;

const AudioSvgIcon = styled(AudioSvg)`
  ${baseStylesForIcon}
`;

const DocumentSvgIcon = styled(DocumentSvg)`
  ${baseStylesForIcon}
`;

const FlagSvgIcon = styled(FlagSvg)`
  ${baseStylesForIcon}
`;

const InterrogationSvgIcon = styled(InterrogationSvg)`
  ${baseStylesForIcon}
`;

const VideoSvgIcon = styled(VideoSvg)`
  ${baseStylesForIcon}
  max-width: 14px;
`;

const CardsSvgIcon = styled(CardsSvg)`
  ${baseStylesForIcon}
  max-width: 14px;
`;

const AttentionSvgIcon = styled(AttentionSvg)`
  ${baseStylesForIcon}
  max-width: 16px;
  max-height: 16px;
`;

const HeartSvgIcon = styled(HeartSvg)`
  ${baseStylesForIcon}
  max-width: 14px;
  max-height: 15px;
  margin-right: 5px;
`;

const StarSvgIcon = styled(StarSvg)`
  ${baseStylesForIcon}
  max-width: 16px;
  max-height: 16px;
  margin-right: 5px;
`;

const ThumbUpSvgIcon = styled(ThumbUpSvg)`
  ${baseStylesForIcon}
  max-width: 16px;
  max-height: 16px;
  margin-right: 6px;
`;

const ThumbDownSvgIcon = styled(ThumbDownSvg)`
  ${baseStylesForIcon}
  max-width: 16px;
  max-height: 16px;
  margin-right: 6px;
`;

const LockSvgIcon = styled(LockSvg)`
  ${baseStylesForIcon}
  max-width: 16px;
  max-height: 16px;
  margin-right: 6px;
`;

const PasswordSvgIcon = styled(PasswordSvg)`
  ${baseStylesForIcon}
  max-width: 16px;
  max-height: 16px;
  margin-right: 6px;
`;

const SlidersSvgIcon = styled(SlidersSvg)`
  ${baseStylesForIcon}
  max-width: 16px;
  max-height: 16px;
  margin-right: 6px;
`;

export const getIcon = (icon?: string) => {
  switch (icon) {
    case 'light_bulb':
      return LightBulbIcon;
    case 'audio':
      return AudioSvgIcon;
    case 'video':
      return VideoSvgIcon;
    case 'cards':
      return CardsSvgIcon;
    case 'document':
      return DocumentSvgIcon;
    case 'flag':
      return FlagSvgIcon;
    case 'question':
    case 'interrogation':
      return InterrogationSvgIcon;
    case 'attention':
      return AttentionSvgIcon;
    case 'heart':
      return HeartSvgIcon;
    case 'star':
      return StarSvgIcon;
    case 'thumb_up':
      return ThumbUpSvgIcon;
    case 'thumb_down':
      return ThumbDownSvgIcon;
    case 'lock':
      return LockSvgIcon;
    case 'password':
      return PasswordSvgIcon;
    case 'sliders':
      return SlidersSvgIcon;
    default:
      return null;
  }
};
